import React from 'react';
import { NavLink } from 'react-router-dom';

const ShowOrgDaily = ({organizations}) => {
    return (
        <div 
        className="grid grid-cols-1 gap-4 sm:grid-cols-2"
        style={{
            maxHeight: '75vh',
            overflow: 'auto',
            padding: 5
            }}
        >
        {organizations?.map((organization, index) => (
          <div key={index} className="bg-gray-50 sm:rounded-lg">
          <div className="px-4 py-5 sm:p-6">
            <h3 className="text-lg leading-6 font-medium text-gray-900">{organization?.company}</h3>
            <div className="mt-2 max-w-xl text-sm text-gray-500">
              <p><b>Number of daily projects:</b> {organization?.value}</p>
            </div>
            <div className="mt-5">
              <NavLink
              exact
              to={'/organization/' + organization.company}
              style ={{textDecoration:'none'}}
              >
                <button
                type="button"
                className="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mb-1 sm:ml-1"
                >
                  Organization details
                </button>
              </NavLink>
              <NavLink
              exact
              to={'/projectsAllContent/' + organization.company}
              style ={{textDecoration:'none'}}
              >
                <button
                type="button"
                className="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white ml-1 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 "
                >
                  Projects with all content
                </button>
              </NavLink>
            </div>
          </div>
        </div>
          ))}
      </div>
    )
}

export default ShowOrgDaily